'use strict';

import CollapseManager from "../../js/components/collapseManager";

export default class DistancesCard extends HTMLElement
{
    constructor()
    {
        super();
        this.distances = JSON.parse(this.getAttribute('distances'));
        this.stylesheet = this.getAttribute('stylesheet');
        this.numDistancesCollapsed = 5;
    }

    static get observedAttributes()
    {
        return ['distances', 'stylesheet'];
    }

    connectedCallback()
    {
        let shadow = this.attachShadow({mode: 'open'});
        const template = document.querySelector('#distances-card');
        const instance = template.content.cloneNode(true);
        let numItems = this._createList(instance);

        let linkElem = document.createElement('link');
        linkElem.setAttribute('rel', 'stylesheet');
        linkElem.setAttribute('href', this.stylesheet);

        shadow.appendChild(linkElem);
        shadow.appendChild(instance);

        if (numItems > this.numDistancesCollapsed) {
            new CollapseManager(shadow);
        } else {
            shadow.querySelector('[data-entity="collapse"]').classList.remove('collapsed', 'collapse');
            shadow.querySelector('[data-collapse-toggle="collapse-distance-list"]').remove();
            shadow.querySelector('[name="over-text-shadow"]').remove();
        }

        return shadow;
    }

    _createList(instance)
    {
        let numItems = 0;
        let list = instance.querySelector('.distance-list');
        let distanceTypeTemplate = list.querySelector('.distance-type');
        let distanceType;
        for (let type of this.distances) {
            distanceType = distanceTypeTemplate.cloneNode(true);
            distanceType.querySelector('.distance-type-title').innerHTML = type.title
            for (let distance of type.items) {
                let item = document.querySelector('#distance-card').content.cloneNode(true);
                item.querySelector('[name="site-name"]').innerHTML = distance.site;
                item.querySelector('[name="distance"]').innerHTML = distance.distance;
                item.querySelector('[name="distance-metric"]').innerHTML = distance.distanceMetric;
                item.querySelector('[name="icon-transport"]').innerHTML = `<i class="ci ${distance.iconDistance}"></i>`;
                item.querySelector('[name="time"]').innerHTML = distance.time;
                item.querySelector('[name="time-metric"]').innerHTML = distance.timeMetric;
                distanceType.querySelector('.distance-type-items').appendChild(item);
                numItems++;
            }
            if (this.distances[this.distances.length - 1] === type) {
                distanceType.classList.add('last-distance-type-element')
            }
            list.appendChild(distanceType);

        }

        distanceTypeTemplate.remove();
        return numItems;
    }
}
